/**
 * Segni «[da verificare]» nel foglio del verbale: ricerca nel DOM dell'editor,
 * evidenziazione con la CSS Custom Highlight API (non tocca l'HTML salvato) e
 * salto al segno con la selezione sopra (scrivendo si sostituisce).
 * Senza `CSS.highlights` (browser vecchi) l'evidenziazione semplicemente manca.
 */
import { FORMA_DA_VERIFICARE } from './verbaleSezioni';

export const NOME_EVIDENZIAZIONE = 'verbale-da-verificare';

/** Intervalli dei segni nei nodi di testo di `radice`, nell'ordine del documento. */
export function trovaSegniDaVerificare(radice: HTMLElement | null | undefined): Range[] {
  if (!radice || typeof document === 'undefined' || typeof document.createTreeWalker !== 'function') return [];
  const intervalli: Range[] = [];
  const cammino = document.createTreeWalker(radice, NodeFilter.SHOW_TEXT);
  let nodo = cammino.nextNode();
  while (nodo) {
    const testo = nodo.nodeValue || '';
    const re = new RegExp(FORMA_DA_VERIFICARE, 'gi');
    let m = re.exec(testo);
    while (m) {
      const r = document.createRange();
      r.setStart(nodo, m.index);
      r.setEnd(nodo, m.index + m[0].length);
      intervalli.push(r);
      m = re.exec(testo);
    }
    nodo = cammino.nextNode();
  }
  return intervalli;
}

type RegistroEvidenziazioni = { set: (nome: string, h: unknown) => void; delete: (nome: string) => void };

function registro(): { reg: RegistroEvidenziazioni; Highlight: new (...r: Range[]) => unknown } | null {
  const css = (typeof window !== 'undefined' ? (window as unknown as { CSS?: { highlights?: RegistroEvidenziazioni } }).CSS : undefined);
  const Highlight = typeof window !== 'undefined' ? (window as unknown as { Highlight?: new (...r: Range[]) => unknown }).Highlight : undefined;
  if (!css?.highlights || typeof Highlight !== 'function') return null;
  return { reg: css.highlights, Highlight };
}

/** Evidenzia gli intervalli (nessuno ⇒ toglie l'evidenziazione). */
export function evidenziaSegni(intervalli: Range[]): void {
  const r = registro();
  if (!r) return;
  if (intervalli.length === 0) r.reg.delete(NOME_EVIDENZIAZIONE);
  else r.reg.set(NOME_EVIDENZIAZIONE, new r.Highlight(...intervalli));
}

export function togliEvidenziazione(): void {
  registro()?.reg.delete(NOME_EVIDENZIAZIONE);
}

/** Porta in vista il segno e lo seleziona (l'editor riceve il fuoco se modificabile). */
export function selezionaSegno(intervallo: Range, editor: HTMLElement | null | undefined): void {
  const elemento = intervallo.startContainer.parentElement;
  if (editor && editor.isContentEditable && typeof editor.focus === 'function') editor.focus({ preventScroll: true });
  const sel = typeof window !== 'undefined' ? window.getSelection() : null;
  if (sel) {
    sel.removeAllRanges();
    sel.addRange(intervallo.cloneRange());
  }
  if (elemento && typeof elemento.scrollIntoView === 'function') elemento.scrollIntoView({ behavior: 'smooth', block: 'center' });
}

/** Indice di sezione (= indice dell'`<h2>` nel foglio) in cui cade l'intervallo; -1 prima del primo titolo. */
export function sezioneDelSegno(intervallo: Range, titoli: ArrayLike<Element>): number {
  let indice = -1;
  for (let i = 0; i < titoli.length; i += 1) {
    // eslint-disable-next-line no-bitwise
    if (titoli[i].compareDocumentPosition(intervallo.startContainer) & Node.DOCUMENT_POSITION_FOLLOWING) indice = i;
    else break;
  }
  return indice;
}
